import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedEvent: null,
};

const eventSlice = createSlice({
  name: 'event',
  initialState,
  reducers: {
    selectEvent: (state, action) => {
      state.selectedEvent = action.payload;
    },
  },
});

export const { selectEvent } = eventSlice.actions;

export default eventSlice.reducer;
